<template>
  <div class="wrapper w-mb2">
    <ul v-if="block.data.style == 'unordered'">
      <li v-for="(item, item_key) in block.data.items" :key="item_key">{{ item }}</li>
    </ul>
    <ol v-if="block.data.style == 'ordered'">
      <li v-for="(item, item_key) in block.data.items" :key="item_key">{{ item }}</li>
    </ol>
  </div>
</template>
<script>
export default {
  name: "ListBlock",
  props: ["block"],
};
</script>
<style lang="scss" scoped>
</style>
